var ANIMS = {
  viewport_callbacks: [],
  viewport_objs: [],
  viewport_interval: null,
  start_timestamp: null,
  init: function() {
  	console.log('hi')
		ANIMS.initFadeAnims();
    ANIMS.initNumberAnims();
	},
  initFadeAnims: function() {
		var items = $(".ay-fade-anim");
		if(items.length > 0)
		{
			var viewport_objs = [];
			for(var i=0; i<items.length; i++)
			{
				var obj = $(items[i]);
				obj.css("opacity", obj.attr("data-start"));
				viewport_objs.push(items[i]);
			}

			ANIMS.checkObjectsInViewport(viewport_objs, "fade-anim", ANIMS.startFadeAnim);
		}
	},
  initNumberAnims: function() {
		var items = $(".ay-number-anim");
		if(items.length > 0)
		{
			var viewport_objs = [];
			for(var i=0; i<items.length; i++)
			{
				var obj = $(items[i]);
				if(obj.attr("data-start") == "" || obj.attr("data-start") == null)
				{
					var data_end = Number(obj.attr("data-end"));
					var data_start = UTILS.pad("1", obj.attr("data-end").length, false);
					if(data_start >= 10 && Math.abs(data_end - data_start) < 10)
						data_start = UTILS.pad("1", obj.attr("data-end").length-1, false);
					$(obj).attr("data-start", data_start);
				}
				obj.html(obj.attr("data-start"));
				viewport_objs.push(items[i]);
			}

			ANIMS.checkObjectsInViewport(viewport_objs, "number-anim", ANIMS.startNumberAnim);
		}
	},
  checkObjectsInViewport: function(objs_array, obj_action, obj_callback) {
		if(ANIMS.viewport_objs == null)
		{
			ANIMS.viewport_objs = [];
			ANIMS.viewport_callbacks = [];
		}

		ANIMS.viewport_objs = ANIMS.viewport_objs.concat(objs_array);
		ANIMS.viewport_callbacks[obj_action] = obj_callback;

		for(var i=0; i<objs_array.length; i++)
		{
			$(objs_array[i]).attr("viewport-dispatched", "0");
			$(objs_array[i]).attr("viewport-action", obj_action);
		}

		clearInterval(ANIMS.viewport_interval);
		ANIMS.viewport_interval = setInterval(ANIMS.checkObjectsInViewportEvent, 100);
		ANIMS.checkObjectsInViewportEvent();
	},
  checkObjectsInViewportEvent: function() {
		var keep_checking = false;
		for(var i=0; i<ANIMS.viewport_objs.length; i++)
		{
			var obj = $(ANIMS.viewport_objs[i]);
			if(obj.attr("viewport-dispatched") == "0")
			{
				keep_checking = true;
				if(ANIMS.isElementInView(obj, false))
				{
					obj.attr("viewport-dispatched", "1");
					if(obj.attr("viewport-callback") != "")
					{
						var diff = new Date().getTime() - ANIMS.start_timestamp;
						if(diff < 100)
							setTimeout(UTILS.cleanDelegate(this, ANIMS.checkObjectsInViewportCallback, [obj]), 125);
						else
							setTimeout(UTILS.cleanDelegate(this, ANIMS.checkObjectsInViewportCallback, [obj]), 250);
					}
				}
			}
		}

		if(!keep_checking)
		{
			clearInterval(ANIMS.viewport_interval);
		}
	},

	checkObjectsInViewportCallback: function(obj) {
		var action = obj.attr("viewport-action");
		var callback = ANIMS.viewport_callbacks[action];
		callback.apply(null, obj)
	},

  isElementInView: function (element, fullyInView) {
    var pageTop = $(window).scrollTop();
    var pageBottom = pageTop + $(window).height();
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).height();

    if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom));
    } else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
    }
  },

  startFadeAnim: function(obj) {
		$(obj).fadeTo(Number($(obj).attr("data-anim-time")), Number($(obj).attr("data-end")));
	},

  startNumberAnim: function(obj) {
		var data_start = Number($(obj).attr("data-start"));
		var data_end = Number($(obj).attr("data-end"));
		var duration = Number($(obj).attr("data-anim-time"));
		var steps = duration/100;
		var step_diff = (data_end - data_start) / steps;
		//console.log(data_start+"|"+data_end+"|"+duration+"|"+steps+"|"+step_diff);

		$(obj).attr("data-step", 0);
		$(obj).attr("data-total-steps", steps);
		$(obj).attr("data-step-incr", step_diff);
		setTimeout(UTILS.cleanDelegate(this, ANIMS.numberAnimEvent, [obj]), 100);
	},
  
  numberAnimEvent: function(obj) {
		var step = Number($(obj).attr("data-step"));
		step ++;
		$(obj).attr("data-step", step);
		var step_diff = Number($(obj).attr("data-step-incr"));
		var data_start = Number($(obj).attr("data-start"));
		var steps = Number($(obj).attr("data-total-steps"));
		var data_now = Number($(obj).attr("data-end"));
		if(step < steps)
		{
			data_now = Math.round(data_start + step_diff*step);
			setTimeout(UTILS.cleanDelegate(this, ANIMS.numberAnimEvent, [obj]), 100);
		}
		$(obj).html(data_now);
	}
}
